<template>
  <a :href="link" target="_blank" class="spush-page-deeplink-button">
    <div class="spush-page-deeplink-button__text">{{ $t('spush_page__deeplink') }}</div>
    <div class="spush-page-deeplink-button__icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none">
        <g clip-path="url(#clip0_1_1566)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.293 8.98041C10.1055 9.16794 10.0002 9.42224 10.0002 9.68741C10.0002 9.95257 10.1055 10.2069 10.293 10.3944L12.414 12.5154L10.293 14.6364C10.1053 14.8239 9.99985 15.0783 9.99976 15.3436C9.99966 15.6088 10.1049 15.8633 10.2925 16.0509C10.48 16.2385 10.7343 16.344 10.9996 16.3441C11.2649 16.3442 11.5193 16.2389 11.707 16.0514L14.536 13.2224C14.7234 13.0349 14.8287 12.7806 14.8287 12.5154C14.8287 12.2502 14.7234 11.9959 14.536 11.8084L11.707 8.98041C11.5194 8.79294 11.2651 8.68762 11 8.68762C10.7348 8.68762 10.4805 8.79294 10.293 8.98041Z"
            fill="var(--spush-second-color)" />
        </g>
        <defs>
          <clipPath id="clip0_1_1566">
            <rect width="24" height="24" fill="white" transform="translate(0 0.515381)" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.spush-page-deeplink-button {
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 42px;
  border-radius: 40px;
  background-color: var(--spush-main-color);

  &__text {
    color: var(--spush-second-color);
    margin-right: 5px;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  &__icon {
    height: 24px;
  }
}
</style>
